module.exports = __webpack_public_path__ + "img/d195e2a478d73658b49d052166062a9f.png";